import React from "react";
import PropTypes from "prop-types";
import withCustomStyles from "./CategoryChipPart.style";
import { GChip } from "./ui";
import { _isUndefined } from "../utils/HelperUtils";

// Category / brand filter chip: grey idle, black selected.
class CategoryChipPart extends React.Component {
  render() {
    const {
      props: { classes, label, onClick, isSelected, to }
    } = this;

    return (
      <GChip
        className={classes.chip}
        selected={Boolean(isSelected)}
        onClick={onClick}
        to={_isUndefined(to) ? undefined : to}
      >
        {label}
      </GChip>
    );
  }
}

CategoryChipPart.propTypes = {
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  isSelected: PropTypes.bool,
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
};

export default withCustomStyles(CategoryChipPart);
